import { getAvailableLanguages } from '@accredible-frontend-v2/services/language';
import { AccredibleUserApiService } from '@accredible-frontend-v2/services/user';
import { accredibleCustomThemesMetadata } from '@accredible-frontend-v2/utils/themes';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Event, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter } from 'rxjs/operators';
import { ThemeHelper } from '../../theme.helper';

@UntilDestroy()
@Component({
  templateUrl: './footer.component.html',
  styleUrls: [`./footer.component.scss`],
})
export class FooterComponent implements OnInit {
  themeName = ThemeHelper.getTheme();
  languages = getAvailableLanguages(accredibleCustomThemesMetadata[this.themeName].languages);
  username: string;

  constructor(
    @Inject(DOCUMENT) private readonly _document: Document,
    private readonly _router: Router,
    private readonly _userApi: AccredibleUserApiService,
  ) {}

  ngOnInit(): void {
    this._router.events
      .pipe(
        untilDestroyed(this),
        filter((event: Event | RouterEvent) => event instanceof NavigationEnd),
      )
      .subscribe(() => {
        const pathname = this._document.location.pathname;
        if (pathname.indexOf('/profile/') > -1) {
          // If we are on a profile
          this.username = pathname.split('/')[2];
        } else {
          this.username = this._userApi.getUser()?.username;
        }
      });
  }
}
